import type { CreatorEntity, CreatorType } from "shared/schema";
import { MenuButton, Page } from "shared/react";
import { EntityBackgroundHeader } from "../entity/EntityBackgroundHeader.js";
import { ChallengeButton, EntityButton } from "../entity/EntityButton.js";
import { useItem } from "../util/db.js";
import { LeaderboardJoinCard } from "./LeaderboardJoinCard.js";
import { LeaderboardMenu } from "./LeaderboardMenu.js";
import { LeaderboardSentences } from "./LeaderboardSentence.js";
import { LeaderboardTable } from "./LeaderboardTable.js";

/**
 * Show a leaderboard for a given challenge and target (i.e. group).
 * - Shows a list of each task in the challenge with a table of placements for every task.
 */
export function LeaderboardPage({ type, id, cid }: { type: CreatorType; id: string; cid: string }): React.ReactElement {
	const creator: CreatorEntity = `${type}:${id}`;
	const { tasks } = useItem("challenge", cid).data;
	return (
		<Page title="Leaderboard">
			<EntityBackgroundHeader entity={creator} mods="pad-none">
				<section className="pad-none space-none">
					<div className="pad-3x width-wide">
						<h1>Leaderboard</h1>
						<ChallengeButton id={cid} />
					</div>
					<EntityButton entity={creator} mods="pin-bottom pin-left size-small" />
					<MenuButton menu={<LeaderboardMenu creator={creator} cid={cid} />} mods="button-quiet pin-top pin-right" />
				</section>
				<section className="panel pad-xsmall size-small">
					<LeaderboardSentences creator={creator} cid={cid} />
				</section>
			</EntityBackgroundHeader>
			<LeaderboardJoinCard creator={creator} cid={cid} />
			{Object.entries(tasks).map(([tid, { title }]) => (
				<section key={tid}>
					<h2>{title}</h2>
					<LeaderboardTable creator={creator} cid={cid} tid={tid} empty="No leaders" />
				</section>
			))}
		</Page>
	);
}
